const WHATSAPP_URL = 'https://wa.me/5511986765185?text=Preciso%20de%20um%20or%C3%A7amento.';

const vantagens = [
  {
    icon: 'ri-shield-check-line',
    title: 'Padrão Estético Garantido',
    desc: 'Definimos o modelo ideal que respeita a fachada do seu condomínio.',
  },
  {
    icon: 'ri-gift-line',
    title: 'Comissões Especiais',
    desc: 'Como forma de boas-vindas ao prédio, oferecemos comissões e descontos exclusivos para os primeiros clientes de cada condomínio.',
  },
  {
    icon: 'ri-time-line',
    title: 'Agilidade na Instalação',
    desc: 'Prioridade total para as primeiras unidades que fecharem conosco.',
  },
  {
    icon: 'ri-building-line',
    title: 'Consulte seu Condomínio',
    desc: 'Verifique se o seu condomínio já faz parte desta campanha e garanta o padrão Thelux com benefício especial.',
  },
];

export default function PrimeirosClientes() {
  return (
    <section className="py-16 md:py-24 bg-stone-50">
      {/* Texto de posicionamento - acima da seção principal */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 mb-12">
        <div className="text-center">
          <div className="inline-flex items-center gap-3 bg-white border border-stone-200 rounded-full px-6 py-3 shadow-sm">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-star-line text-amber-600 text-lg"></i>
            </div>
            <p className="text-stone-800 font-semibold text-sm">
              Nosso orçamento não é o mais barato, é o justo.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1 order-2 lg:order-1">
            <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
              PROGRAMA EXCLUSIVO — PRIMEIROS CLIENTES
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 leading-tight mb-4">
              Seja o Primeiro a Transformar sua Varanda com Condições Exclusivas.
            </h2>
            <p className="text-stone-600 text-sm mb-8 leading-relaxed">
              Acabou de receber as chaves? O seu novo lar merece a sofisticação e a proteção da Vidros Thelux. Para celebrar a chegada em novos empreendimentos, lançamos o programa{' '}
              <strong className="text-stone-800">"Primeiros Clientes"</strong>.
            </p>
            <ul className="space-y-5 mb-8">
              {vantagens.map((v) => (
                <li key={v.title} className="flex gap-4 items-start">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-100 text-amber-600 shrink-0 mt-0.5">
                    <i className={`${v.icon} text-lg`}></i>
                  </div>
                  <div>
                    <p className="font-semibold text-stone-800 text-sm">{v.title}</p>
                    <p className="text-stone-500 text-sm leading-relaxed">{v.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-stone-900 hover:bg-stone-700 text-white font-semibold px-7 py-3 rounded-full text-xs transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              CONSULTAR DISPONIBILIDADE
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line"></i>
              </div>
            </a>
          </div>

          <div className="flex-1 order-1 lg:order-2 w-full">
            <div className="relative rounded-2xl overflow-hidden w-full h-[320px] md:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=brand%20new%20luxury%20apartment%20balcony%20with%20open%20frameless%20glass%20panels%20modern%20architecture%20S%C3%A3o%20Paulo%20high%20rise%20building%20natural%20light%20elegant%20interior%20design%20premium%20finish&width=800&height=960&seq=primeiros001&orientation=portrait"
                alt="Sacada articulada com vidro em apartamento novo"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute top-4 left-4 bg-amber-500 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">
                Programa Exclusivo
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}